<template>
  <v-dialog v-model="dialogStatus" max-width="600" transition="dialog-bottom-transition">
    <v-card class="mx-auto">
      <div class="d-flex align-end mb-3">
        <v-card class="green py-4 px-4 ml-6 mr-3 mt-6">
          <v-icon color="white"> mdi-bookmark </v-icon>
        </v-card>
        <span class="h4 ml-1 mb-n1">类型定义</span>
      </div>
      <v-tabs v-model="tab" background-color="transparent" color="basil" grow>
        <v-tabs-slider color="green"></v-tabs-slider>
        <v-tab v-for="item in items" :key="item">
          {{ item }}
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-form class="pa-4" ref="form" v-model="valid" lazy-validation dense>
            <v-text-field
              v-model="form.structId"
              disabled
              label="设备编码"
              color="green lighten-1"
              :rules="[v => !!v || '设备编码不能为空']"
              hint="请使用英文/字符,首字母不要使用字符，不能重复"
            ></v-text-field>
            <v-text-field
              v-model="form.name"
              label="设备名称"
              color="green lighten-1"
              :rules="[v => !!v || '设备名称不能为空']"
            >
            </v-text-field>
            <v-text-field
              v-model="form.tag"
              label="设备标签"
              color="green lighten-1"
              :rules="[v => !!v || '设备标签不能为空']"
            ></v-text-field>
            <v-text-field
              v-model="form.info"
              label="设备信息"
              color="green lighten-1"
              :rules="[v => !!v || '设备信息不能为空']"
            >
            </v-text-field>
            <v-switch v-model="form.isStatic" color="success" :label="`是否静态`"></v-switch>
            <!-- <v-row justify="space-between">
              <v-col cols="10" md="10">
                <v-select v-model="form.deviceTypeId" :items="typeListData" color="green lighten-1" item-text="name"
                  no-data-text="暂无类型" item-value="_id" label="设备类型" :rules="[(v) => !!v || '设备类型不能为空']">
                  <template v-slot:append-item>
                    <v-list-item class="v-list-item--link" ripple @mousedown.prevent value="self_def"
                      @click.native="showBaseExtDialog = true">
                      <v-list-item-content @click.stop="handleChangeTypeStatus(true)">
                        <v-list-item-title> 自定义 </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2"></v-divider>
                  </template>
                </v-select>
              </v-col>
              <v-col cols="2" md="2">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon large color="green darken-2" @click.native="handleChangeTypeStatus('edit')" v-bind="attrs"
                      v-on="on" style="font-size: 26px; margin-top: 20px">mdi-message-text</v-icon>
                  </template>
                  <span>设备详细信息</span>
                </v-tooltip>
              </v-col>
            </v-row> -->
          </v-form>
        </v-tab-item>
        <v-tab-item>
          <v-list class="pa-3">
            <v-list-item-group
              v-model="form.deviceTypeId"
              active-class="deep-purple--text text--accent-4"
            >
              <v-list-item v-for="(item, i) in typeListData" :key="i" :value="item._id">
                <template v-slot:default="{ active }">
                  <v-list-item-action>
                    <v-checkbox :input-value="active" color="purple" size="mini"></v-checkbox>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title class="text-body" v-text="item.name"></v-list-item-title>
                    <v-list-item-subtitle v-text="item.description"></v-list-item-subtitle>
                  </v-list-item-content>
                  <v-spacer></v-spacer>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        color="green"
                        small
                        v-bind="attrs"
                        v-on="on"
                        @click.stop="handleTypeEdit(item)"
                      >
                        <v-icon small>mdi-pencil</v-icon>
                      </v-btn>
                    </template>
                    <span>修改设备类型信息</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        icon
                        color="red"
                        small
                        @click.stop="handleTypeDel(item)"
                        :disabled="course_senior"
                      >
                        <v-icon small>mdi-close</v-icon>
                      </v-btn>
                    </template>
                    <span>删除设备类型信息</span>
                  </v-tooltip>
                </template>
              </v-list-item>
            </v-list-item-group>
          </v-list>
          <div class="py-5 d-flex justify-center align-center">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  color="green darken-2"
                  v-bind="attrs"
                  v-on="on"
                  @click.stop="handleChangeTypeStatus('add')"
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>
              <span>新增设备类型</span>
            </v-tooltip>
          </div>
        </v-tab-item>
      </v-tabs-items>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green" dark @click.stop="submit" :disabled="course_senior">提交</v-btn>
        <v-btn color="gray" @click.stop="handleChangeStatus(false)">取消</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Swal from 'sweetalert2';
import { getCourseById } from '@/api/course';
// D:\Project\MetaStation\src\api\task\task.js
export default {
  computed: {
    dialogStatus: {
      get() {
        return this.$store.state.editorDefinition.showDefinition;
      },
      set(val) {
        this.handleChangeStatus(val);
      },
    },
    typeListData() {
      return this.$store.state.editorType.typeList;
    },
  },
  watch: {
    dialogStatus(status) {
      this.$nextTick(() => {
        this.$refs.form?.resetValidation();
      });
      if (status) {
        this.form = Object.assign({}, this.$store.state.editorDefinition.definitionForm);
        this.form.isStatic = this.form.isStatic === undefined ? true : this.form.isStatic;
      }
    },
  },
  data() {
    return {
      tab: '',
      items: ['基本信息', '设备类型'],
      form: {},
      valid: false,
      reveal: false,
      course_senior: false,
    };
  },
  methods: {
    submit() {
      if (!this.valid) {
        this.$store.commit('SHOW_SNACKBAR', { color: 'warning', text: '请填写完整表单项' });
        return;
      }
      this.form.sceneId = this.$route.params.editorId;
      this.$store.dispatch('editorDefinition/saveDefinition', this.form);
    },
    async handleTypeDel(item) {
      let result = await Swal.fire({
        title: '提示',
        text: `确认 删除${item.name}？`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'md-button md-success btn-fill',
        cancelButtonClass: 'md-button md-danger btn-fill',
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        buttonsStyling: false,
      });

      if (result.value) {
        this.$store.dispatch('editorType/removeType', item._id);
      }
    },
    handleTypeEdit(typeInfo) {
      this.$store.dispatch('editorType/setTypeInfo', Object.assign({}, typeInfo));
      this.handleChangeTypeStatus('edit');
    },
    handleChangeStatus(status) {
      this.$store.dispatch('editorDefinition/reverseDefinitionStatus', status);
    },
    handleChangeTypeStatus(status) {
      this.$store.dispatch('editorType/reverseShowTypeStatus', status);
      if (status !== 'edit') {
        this.$store.dispatch('editorType/setEmptyTypeInfo');
      }
    },
    getUserId() {
      let userId = '';
      if (window.localStorage.getItem('USER_INFO')) {
        let data = JSON.parse(window.localStorage.getItem('USER_INFO'));
        userId = data.user._id;
      } else {
        userId = '';
      }
      return userId;
    },
    queryCourse() {
      if (this.$route.params.courseId) {
     
        getCourseById(this.$route.params.courseId).then(res => {
          //普通模式不能点击模型
          if (res.data) {
            if (res.data.hasAuthModify) {
              //自己创建的课程和协作课程 true 可以修改并且查看
              // this.course_senior = false; //不禁用
              if (res.data.is_senior == false) {
                  //普通模式
                  this.course_senior = true;
                } else {
                  //高级模式
                  this.course_senior = false;
                }

            } else {
              //不是自己创建的课程 如果是普通模式//禁用

              if (res.data.is_open == true) {
                this.course_senior = true; //公开课程禁用 只能查看
              } else {
                if (res.data.is_senior == false) {
                  //普通模式
                  this.course_senior = true;
                } else {
                  //高级模式
                  this.course_senior = false;
                }
              }
            }
          }
        });
      }
    },
  },
  created() {
    this.queryCourse();
  },
};
</script>

<style>
</style>
